<template>
  <div>
    <ProductSizesModal
      v-if="sizesModalIsVisible"
      :list="selectedProduct.quantity_data"
      :readonly="!buttonsAreVisible"
      @close="closeModal"
    />
    <label class="control-label">
      Продукты
      <span>(всего: {{ totalProducts }})</span>
      <span v-if="buttonsAreVisible" class="field__label_required">*</span>
      <i
        v-if="buttonsAreVisible"
        class="fa fa-fw fa-plus-circle control-label__icon"
        @click="$emit('on-plus-click')"
      />
    </label>
    <TransitionGroup
      class="list__wrapper_references vert-scroll"
      name="references-list"
      tag="div"
    >
      <div
        class="wrapper__input"
        v-for="product in list"
        :key="product.id"
        v-if="typeof list === 'object'"
      >
        <input
          class="form-control input__elem_product"
          type="text"
          :value="getDescription(product)"
          readonly
        />
        <div class="input__buttons">
          <div>
            <DatePicker
              class="wrapper__timepicker"
              type="time"
              format="HH:mm"
              placeholder="Время"
              :default-value="defaultDate"
              :time-picker-options="timePickerOptions"
              :disabled="!buttonsAreVisible"
              v-model="product.each_item_deadline"
              @change="$emit('on-deadlines-change')"
            >
              <template slot="header">
                <span>Время на изготовление 1 изделия</span>
              </template>
            </DatePicker>
          </div>
          <button
            class="btn btn-default btn-icon"
            type="button"
            @click="openModal(product)"
          >
            <RulerIcon />
          </button>
          <button
            class="btn btn-default btn-icon"
            type="button"
            @click="goToAnotherForm(product)"
          >
            <i class="fa fa-link"></i>
          </button>
          <button
            v-if="buttonsAreVisible"
            class="btn btn-default btn-icon"
            type="button"
            @click="$emit('on-remove', product)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </TransitionGroup>
    <div v-if="list.length === 0" class="wrapper__text_without-products">
      <span>Нет значений</span>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import RulerIcon from "@/stock/components/icons/RulerIcon";
import ProductSizesModal from "@/stock/widgets/project/ProductSizesModal";
import "vue2-datepicker/index.css";
export default {
  emits: [
    "on-plus-click",
    "on-change",
    "on-delete",
    "on-counts-update",
    "on-deadlines-change",
  ],
  components: {
    DatePicker,
    RulerIcon,
    ProductSizesModal,
  },
  props: {
    list: {
      type: Array | String,
      default() {
        return [];
      },
    },
    buttonsAreVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sizesModalIsVisible: false,
      timePickerOptions: {
        start: "00:30",
        step: "00:05",
        end: "02:00",
        format: "HH:mm",
      },
    };
  },
  computed: {
    defaultDate() {
      const value = new Date();
      value.setFullYear(1970, 0, 1);
      return value;
    },
    totalProducts() {
      const DEFAULT_VALUE = 0;
      if (this.list.length === 0) {
        return DEFAULT_VALUE;
      }
      const results = this.list.reduce((acc, val) => (
        acc += val.total_count
      ), 0);
      return results;
    },
  },
  methods: {
    getDescription(product) {
      const totalCount = product.total_count;
      const description = `${product.name} (количество: ${totalCount})`;
      return description;
    },
    closeModal(valuesWereChanged) {
      const emittingData = {
        product: this.selectedProduct,
        valuesWereChanged,
      };
      this.$emit('on-counts-update', emittingData);
      this.selectedProduct = null;
      this.sizesModalIsVisible = false;
    },
    openModal(product = {}) {
      this.selectedProduct = product;
      this.sizesModalIsVisible = true;
    },
    goToAnotherForm(product) {
      const { id } = product;
      const url = `/products/${id}`;
      const routeData = this.$router.resolve(url);
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped>
.wrapper__input {
  margin-bottom: 0.8em;
  display: inline-flex;
  flex-direction: row;
  column-gap: 0.5em;
}
.wrapper__text_without-products {
  padding-top: 0.8em;
}
.wrapper__timepicker {
  max-width: 86px;
}
.input__elem_product {
  min-width: 200px;
}
.input__buttons {
  display: inline-flex;
  flex-direction: row;
}
.input__buttons > * + * {
  margin-left: 0.2em;
}
.control-label__icon:hover,
.control-label__icon:focus {
  cursor: pointer;
  transition: 0.3s;
  opacity: 0.5;
}
@media (max-width: 1023px) {
  .input__elem_product {
    min-width: unset;
  }
}
@media (max-width: 419px) {
  .wrapper__input {
    display: grid;
    grid-template-columns: 100%;
    row-gap: 0.8em;
  }
  .wrapper__timepicker {
    width: 100%;
    max-width: unset;
  }
  .input__buttons {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/stock/components/ProjectProductsList.vue